import { SelectionBar } from '@/shared/ui';
import { ChangePriorityDialog, ConsignmentStatusDialog } from '@/features/consignment-actions';
import type { ConsignmentSummary } from '@/entities/consignments';

import { useConsignmentSelection } from '../model/use-consignment-selection';

interface ConsignmentSelectionBarProps {
  selectedIds: string[];
  consignments?: Pick<ConsignmentSummary, 'id' | 'allowedActions' | 'resetTargetStatusCode'>[];
  onClearSelection?: () => void;
}

export function ConsignmentSelectionBar({ selectedIds, consignments, onClearSelection }: ConsignmentSelectionBarProps) {
  const { selectedCount, selectionActions, dialogs, isSubmitting, isVisible } = useConsignmentSelection({
    selectedIds,
    consignments,
    onClearSelection
  });

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <SelectionBar selectedCount={selectedCount} actions={selectionActions} onClose={onClearSelection} />

      <ChangePriorityDialog
        open={dialogs.changePriority.open}
        onOpenChange={dialogs.changePriority.onOpenChange}
        onConfirm={(priority, comments) => dialogs.changePriority.onConfirm(priority, comments)}
      />

      {dialogs.statusChange.target && (
        <ConsignmentStatusDialog
          open={dialogs.statusChange.open}
          onOpenChange={dialogs.statusChange.onOpenChange}
          target={dialogs.statusChange.target}
          isSubmitting={isSubmitting}
          onConfirm={dialogs.statusChange.onConfirm}
        />
      )}
    </>
  );
}
